import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import App from "./config/App";
import { BrowserRouter as Router } from "react-router-dom";
import { AppProvider } from "./config/AppContext";
import { SnackbarProvider } from "notistack";
import { SnackbarContent } from "notistack";
import { CustomError, CustomSuccess } from "./notification/NotificationStyle";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Router>
      <SnackbarProvider
        maxSnack={8} // Wrap App with SnackbarProvider
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }} // Customize position
        autoHideDuration={6000}
        Components={{
          success: CustomSuccess,
          error: CustomError,
        }}
      >
        <AppProvider>
          <App />
        </AppProvider>
      </SnackbarProvider>
    </Router>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
